import { FETCH_TIMEZONES_FETCHING, FETCH_TIMEZONES_SUCCESS, FETCH_TIMEZONES_FAIL } from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    timezoneUnits: {},
    fetching: false,
    error: false,
    success: false
};

const timezonesFetching = (state) => {
    return {
        ...state,
        timezoneUnits: {
            ...state.timezoneUnits,
            units: null
        },
        fetching: true
    };
};

const timezonesSuccess = (success) => (state, action) => {
    return {
        ...state,
        timezoneUnits: {
            ...state.timezoneUnits,
            units: success ? action.timezones.sort((a, b) => a.gmtOffset - b.gmtOffset) : null
        },
        success: success,
        error: !success,
        fetching: false
    };
};

const handlers = {
    [FETCH_TIMEZONES_FETCHING]: timezonesFetching,
    [FETCH_TIMEZONES_SUCCESS]: timezonesSuccess(true),
    [FETCH_TIMEZONES_FAIL]: timezonesSuccess(false)
};

export default function timeZones(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}

export const getTimezones = (state) => {
    return state.timeZones.timezoneUnits.units;
};

export const isTimezonesFetching = (state) => {
    return state.timeZones.fetching;
};

export const isTimezonesSuccess = (state) => {
    return state.timeZones.success;
};

export const isTimezonesError = (state) => {
    return state.timeZones.error;
};
